import { http } from "Utils/http";
import { Form, Tabs, Tab, Row, Col, Card,Dropdown,Button, Stack,Modal,CloseButton } from "react-bootstrap";
import { useState, useEffect} from "react";
import {useLocation } from 'react-router-dom';
import {store} from 'Store';
import {setGlobalErrorStatus, setGlobalSuccessStatus} from 'Components/StatusHandling'
import { useDispatch } from "react-redux"
import {GetTableauUserCheckboxInputData,  GetTableauUserSelectInputData, GetTableauUserRadioInputData } from 'Containers/Private/Tableau/TableauUserFields';
import {FormInputDisplay} from 'Components/Forms/FormInputDisplay.js';
import { useNavigate} from 'react-router-dom';
import { ERROR_MESSAGES } from "Utils/constants";
import { TextButton } from "Components/Button";

const CreateTableauUser = () => {
    const navigate = useNavigate();

    let location = useLocation();
    var passedData = location.state;
    //console.log("PASSED DATA");
    //console.log(passedData);
    const [backRedirect, setBackRedirect] = useState(passedData.backRedirect);
    //const [isLoading, setIsLoading] = useState(true)

    var dispatch = useDispatch();

    //const loginState = store.getState().loginInfo;

    const ACTIONS = {
        CALL_API: 'call-api',
        SUCCESS: 'success',
        ERROR: 'error',
        SET_INITIAL_DATA: 'set-data',

        TEXT_CHANGE: 'text-change',
        TEXT_SET_ERRORS: 'text-set-errors',
        TEXT_REMOVE_ERRORS: 'text-remove-errors',
        TEXT_AREA_CHANGE: 'text-area-change',

        RADIO_CHANGE: 'radio-change',
        RADIO_SET_ERRORS: 'radio-set-errors',
        RADIO_REMOVE_ERRORS: 'radio-remove-errors',

        SELECT_CHANGE: 'select-change',
        SELECT_SET_ERRORS: 'select-set-errors',
        SELECT_REMOVE_ERRORS: 'select-remove-errors',
        SELECT_UPDATE_CHOICES: 'select-update-choices',

        SET_INITIAL_CHECK_DATA: 'set-check-data',
        CHECK_UPDATE_CHOICES: 'check-update-choices',
        CHECK_CHANGE: 'check-change',
        CHECK_TOGGLE_DISABLE: 'check-toggle-disable',
        //CHECK_REQUIRED_CHANGE: 'check-required-change',
        CHECK_SET_ERRORS: 'check-set-errors',
        CHECK_REMOVE_ERRORS: 'check-remove-errors',

        DATE_CHANGE: 'date-change',
        DATE_SET_ERRORS: 'date-set-errors',
        DATE_REMOVE_ERRORS: 'date-remove-errors',

        PHONE_CHANGE: 'phone-change',
        PHONE_SET_ERRORS: 'phone-set-errors',
        PHONE_REMOVE_ERRORS: 'phone-remove-errors',

        FILE_CHANGE: 'file-change',
        FILE_SET_ERRORS: 'file-set-errors',
    };

    const [isLoading, setIsLoading] = useState(true);

    const hForm = { is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 6 } };
    //const vForm = { is: false, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 7 } };

    var [tableauUserPso, tableauUserPsoInputDispatch] = GetTableauUserSelectInputData('tableauUserPso', null);
    var [tableauUserStatus, tableauUserStatusInputDispatch] = GetTableauUserRadioInputData('tableauUserStatus', 1, false); 
    var [tableauUserAccess, tableauUserAccessInputDispatch] = GetTableauUserCheckboxInputData('tableauUserAccess', ''); 

    useEffect(() => {
        loadFormData();
    }, []);

    const getFormData = async () => {

        var url = '/api/manageTableau/addTableauReportUser';
        const loginState = store.getState().loginInfo;

        return http.post(url, null, {
            timeout: 80000,
            headers: {
                "Authorization": "Bearer " + loginState.token
                //"Referrer-Policy": "strict-origin-when-cross-origin"
            }
        });
    }

    const loadFormData = () => {
        setIsLoading(true);
        getFormData().then((res) => {
            //console.log("getFormData ", res);
            if (res.status != 1) {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: res.globalErrorMessageList[0],
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
            else {
                var d = res.data;

                //console.log(d);

                
                if (d.userPsoList != null) {
                    var o = [];
                    o.push({
                        index: null,
                        value: -1,
                        title: null,
                        displayValue: "Select a PSO who has production submissions",
                        name: null,
                        isSelected: true
                    })
                    d.userPsoList.map((option, index) => {
                        //console.log(option);
                        var owner = {
                            index: index,
                            id: option.userPsoId,
                            value: option.userPsoId,
                            title: null,
                            displayValue: option.userPsoName + " (" + option.userPsoId + ")",
                            isSelected: false,
                            name: option.userPsoOrgId,
                            disabled: false
                        }
                        o.push(owner);
                        //console.log(owner);
                        return owner;
                    });

                    tableauUserPsoInputDispatch({
                        type: ACTIONS.SELECT_UPDATE_CHOICES,
                        options: o
                    })
                }
                if (d.accessList != null) {
                    var o = d.accessList.map((option) => {
                        var role = {
                            id: option.dataPsoId,
                            label: option.dataPsoName + " (" + option.dataPsoId + ")",
                            title: null,
                            name: option.dataPsoId,
                            value: option.dataPsoId,
                            isChecked: option.isActive
                        }
                        //console.log(role);
                        return role;
                    });
                    tableauUserAccessInputDispatch({
                        type: ACTIONS.CHECK_UPDATE_CHOICES,
                        options: o
                    })
                }
            }
            setIsLoading(false);
            return d;
        }).catch((error) => {
            //console.log("Error caught while loading data: " + error);

            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        
    };

    const handleCancel = async () => {
        if (backRedirect.path == null) {
            setBackRedirect("/manage/tableau");
        }
        navigate(
            backRedirect.path != null ? backRedirect.path : "/manage/tableau",
            { state: backRedirect.state }
        );
    };

    const fieldDataAccess = {
      
        userPsoId: {
            value: tableauUserPso,
            dispatch: tableauUserPsoInputDispatch
        },
        selectedStatus: {
            value: tableauUserStatus,
            dispatch: tableauUserStatusInputDispatch
        },
        "psoAccessList[0].isActive": {
            value: tableauUserAccess,
            dispatch: tableauUserAccessInputDispatch
        }
    }

    function addErrorMessages (object, fieldErrors, dispatch, isFirst) {
        //console.log("ADD ERROR MESSAGES", object, fieldErrors);

        if (fieldErrors != null) {

            var err = fieldErrors.errorMessages;


            if (isFirst == true) {
                (object.InputRef).current.focus();
                //console.log("ISFIRST");
            }

            var type = object.type;

            switch (type) {
                case "text":
                    dispatch({
                        type: ACTIONS.TEXT_SET_ERRORS,
                        errors: err
                    })
                    break;
                 case "select":
                    dispatch({
                        type: ACTIONS.SELECT_SET_ERRORS,
                        errors: err
                    })
                    break;
                case "radio":
                    dispatch({
                        type: ACTIONS.RADIO_SET_ERRORS,
                        errors: err
                    })
                    break;
                case "checkbox":
                    dispatch({
                        type: ACTIONS.CHECK_SET_ERRORS,
                        errors: err
                    })
                    break;
            }

        }
    }

    const getSelectedPso = () => {
        var l = tableauUserPso.options;

        //console.log(l);
        for(var x = 0 ; x<l.length ; x++){
            if(l[x].isSelected==true && l[x].value!=-1){
                return l[x].name + ":" + l[x].value;
            }
        }
        return null;
    }
    
    const getSelectedPsoAccess = () => {
        var l = tableauUserAccess.checkBoxes;
        var accessList = [];
        //console.log(l);
        for(var x = 0 ; x<l.length ; x++){
            if(l[x].isChecked==true){
                var val = {
                    dataPsoId: l[x].value,
                    dataPsoName: l[x].label,
                    isActive: l[x].isChecked
                }
                accessList.push(val);
            }
        }
        
        return accessList;
    }

    const handleSubmit = async () => {
        
        var url = '/api/manageTableau/createTableauReportUser';
        var values = {
            selectedStatus: tableauUserStatus.getValue(tableauUserStatus.radioButtons)
        };
        
        var selectedPso= getSelectedPso();
        if(selectedPso!=null){
            values["selectedPso"] = selectedPso;
        }
        
        var selectedPsoAccess= getSelectedPsoAccess();
        if(selectedPsoAccess!=null){
            values["selectedPsoAccess"] = selectedPsoAccess;
        }
        else{
            values["selectedPsoAccess"] = null;
        }
        
        const loginState = store.getState().loginInfo;
        const res = http.post(url, values, {
            timeout: 80000,
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        }).then((response) => {
            //console.log("print out /users/adduser", response);
            if (response != null) {
                //console.log(response);
                var statusCode = response.status;
                if (statusCode != 1) {
                    if (response.globalErrorMessageList && response.globalErrorMessageList.length > 0) {
                        setGlobalErrorStatus({
                            dispatch: dispatch,
                            popupData: {
                                visible: true,
                                title: ERROR_MESSAGES.GENERAL_ERROR.title,
                                msg: response.globalErrorMessageList,
                                showContactHelp: false
                            },
                            redirect: {
                                redirect: false,
                                redirectFirst: false,
                                path: "",
                                data: {}
                            }
                        });
                    }

                    var d = response.fieldErrors;
                    //console.log("field errors", d);

                    var x = 0;
                    var isFirst = false;

                    for (const [key, value] of Object.entries(fieldDataAccess)) {
                        //console.log("Key: ", key);
                        //console.log("Value: ", value);

                       
                        var values = d[key];

                        //console.log("VALUES", values);

                        if (values != null) {
                            var disp = value.dispatch;
                            var obj = value.value;

                            if (x == 0) {
                                isFirst = true;
                            }
                            else {
                                isFirst = false;
                            }
                            addErrorMessages(obj, values, disp, isFirst);
                            x = x + 1;
                        }
                    }
                }
                else {
                    setGlobalSuccessStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: "Success!",
                            msg: "The Interactive Report Users have been added successfully.",
                            //msg: response.message,
                            showContactHelp: false
                        },
                        redirect: {
                            redirect: true,
                            redirectFirst: true,
                            path: backRedirect.path,
                            data: backRedirect.state 
                        }
                    });
                }
            }
            else {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.GENERAL_ERROR.title,
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
               
            }
        }).catch(function (error) {
            //console.log("submitUser", error);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        //console.log("submitUser", res);
        return res;
    };

    return (
        isLoading==false 
        ?
            <Row>
                <Row >
                    <Col xl={11} lg={11} md={12} sm={12}>
                        
                        <Card className="p-4" >
                            <Card.Body className="text-start">
                                <Row>
                                    <h1 id="mainContent" className="header1 text-start mb-3 blue bold" >Add Interactive Report User</h1>
                                </Row>
                                <Row>
                                    <Form>
                                        <FormInputDisplay fieldData={tableauUserPso} inputDispatch={tableauUserPsoInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>  
                                        <FormInputDisplay fieldData={tableauUserStatus} inputDispatch={tableauUserStatusInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                        <FormInputDisplay fieldData={tableauUserAccess} inputDispatch={tableauUserAccessInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>                             
                                    
                                        <Stack className="pt-3" direction="horizontal" gap={3}>
                                            {/* Submit Button */}
                                            <TextButton
                                                variant="normal"
                                                onClick={handleSubmit}
                                                content={"Submit"}
                                            >
                                            </TextButton>

                                            {/* Cancel Button */}
                                            <TextButton
                                                variant="outline"
                                                onClick={handleCancel}
                                                content={"Cancel"}
                                            >
                                            </TextButton>
                                        </Stack>
                                    
                                    </Form>
                                </Row>
                                    
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Row>
        : null    
    )
}

export default CreateTableauUser;
